import { useRecoilState } from 'recoil';

import {
  similarVehiclesState,
  specialsVehiclesState,
  vehicleInfoState,
} from '@/states/details-car/vehicle-info.state';

export function useVehicleInfo() {
  const [vehicleInfo, setVehicleInfo] = useRecoilState(vehicleInfoState);
  const [specialsVehicles, setSpecialsVehicles] = useRecoilState(
    specialsVehiclesState
  );
  const [similarVehicles, setSimilarVehicles] =
    useRecoilState(similarVehiclesState);

  return {
    vehicleInfo,
    setVehicleInfo,
    similarVehicles,
    setSimilarVehicles,
    specialsVehicles,
    setSpecialsVehicles,
  };
}
